import '../../scss/password.scss';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

// Common a11y fixes
focusHash();
bindInPageLinks();